<div id="forms" class="page-layout simple fullwidth" fxLayout="column">

    <!-- HEADER -->
    <div class="header accent p-24 h-160" fxLayout="row" fxLayoutAlign="start center">
        <div fxLayout="column" fxLayoutAlign="center start">

        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">

        <div class="h1 pt-32">
            {{'INFO.QUES.TITTLE' | translate}}
        </div>
        <p class="pb-32">
        </p>

        <div class="horizontal-stepper-wrapper">

            <!-- HORIZONTAL STEPPER EXAMPLE -->
            <ng-container *ngIf="typeContent != 2">
                <mat-horizontal-stepper class="mat-elevation-z4" [linear]="true">
                    <mat-step [stepControl]="">
                        <form fxLayout="column">
                            <ng-template matStepLabel>Página 1</ng-template>
                            <div fxFlex="1 0 auto" fxLayout="column">
                                <div *ngFor="let sec1 of Seccion1">
                                    <p style="font-weight: bold">
                                        {{ sec1.pregunta }}
                                    </p>
                                    <table class="" style="width: 100%; margin-bottom: 2%;">
                                        <tbody>
                                            <tr *ngFor="let des of sec1.descripcion">
                                                <th scope="col" style="width: 85%; text-align: left; font-weight: normal;">
                                                    {{des.des}}
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br>
                            </div>
                        </form>
                    </mat-step>

                    <mat-step [stepControl]="">
                        <form fxLayout="column">
                            <ng-template matStepLabel>Página 2</ng-template>
                            <div fxFlex="1 0 auto" fxLayout="column">
                                <div *ngFor="let sec2 of Seccion2">
                                    <p style="font-weight: bold">
                                        {{ sec2.pregunta }}
                                    </p>
                                    <table class="" style="width: 100%; margin-bottom: 2%;">
                                        <tbody>
                                            <tr *ngFor="let des of sec2.descripcion">
                                                <th scope="col" style="width: 85%; text-align: left; font-weight: normal; padding-bottom: 10px;">
                                                    {{des.des}}
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br>
                            </div>
                        </form>
                    </mat-step>

                    <mat-step [stepControl]="">
                        <form fxLayout="column">
                            <ng-template matStepLabel>Página 3</ng-template>
                            <div fxFlex="1 0 auto" fxLayout="column">
                                <div *ngFor="let sec3 of Seccion3">
                                    <p style="font-weight: bold">
                                        {{ sec3.pregunta }}
                                    </p>
                                    <ng-container *ngIf="sec3.img == '2' ">
                                        <img src='./assets/images/norm35/TablaNorma.jpeg' class="centradoIMG ">
                                    </ng-container>

                                    <ng-container *ngIf="sec3.img == '1' ">
                                        <img src='./assets/images/norm35/GestionModelo.jpeg' class="centradoIMG ">
                                    </ng-container>
                                    <table class="" style="width: 100%; margin-bottom: 2%;">
                                        <tbody>
                                            <tr *ngFor="let des of sec3.descripcion">
                                                <th scope="col" style="width: 85%; text-align: left; font-weight: normal;">
                                                    {{des.des}}
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br>
                            </div>
                        </form>
                    </mat-step>

                    <mat-step>
                        <ng-template matStepLabel>Página 4</ng-template>
                        <div fxFlex="1 0 auto" fxLayout="column">
                            <div *ngFor="let sec4 of Seccion4">
                                <p style="font-weight: bold">
                                    {{ sec4.pregunta }}
                                </p>
                                <table class="" style="width: 100%; margin-bottom: 2%;">
                                    <tbody>
                                        <tr *ngFor="let des of sec4.descripcion">
                                            <th scope="col" style="width: 85%; text-align: left; font-weight: normal;">
                                                {{des.des}}
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br>
                        </div>
                    </mat-step>


                </mat-horizontal-stepper>

            </ng-container>
            <ng-container *ngIf="typeContent == 2">
                <mat-horizontal-stepper class="mat-elevation-z4" [linear]="true">
                    <mat-step [stepControl]="">
                        <form fxLayout="column">
                            <ng-template matStepLabel>Página 1</ng-template>
                            <div fxFlex="1 0 auto" fxLayout="column">
                                <div *ngFor="let sec1 of Seccion1Better">
                                    <p style="font-weight: bold">
                                        {{ sec1.pregunta }}
                                    </p>
                                    <table class="" style="width: 100%; margin-bottom: 2%;">
                                        <tbody>
                                            <tr *ngFor="let des of sec1.descripcion">
                                                <th scope="col" style="width: 85%; text-align: left; font-weight: normal;">
                                                    {{des.des}}
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br>
                            </div>
                        </form>
                    </mat-step>

                    <mat-step [stepControl]="">
                        <form fxLayout="column">
                            <ng-template matStepLabel>Página 2</ng-template>
                            <div fxFlex="1 0 auto" fxLayout="column">
                                <div *ngFor="let sec2 of Seccion2Better">
                                    <p style="font-weight: bold">
                                        {{ sec2.pregunta }}
                                    </p>
                                    <table class="" style="width: 100%; margin-bottom: 2%;">
                                        <tbody>
                                            <tr *ngFor="let des of sec2.descripcion">
                                                <th scope="col" style="width: 85%; text-align: left; font-weight: normal; padding-bottom: 10px;">
                                                    {{des.des}}
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br>
                            </div>
                        </form>
                    </mat-step>

                    <mat-step [stepControl]="">
                        <form fxLayout="column">
                            <ng-template matStepLabel>Página 3</ng-template>
                            <div fxFlex="1 0 auto" fxLayout="column">
                                <div *ngFor="let sec3 of Seccion3Better">
                                    <p style="font-weight: bold">
                                        {{ sec3.pregunta }}
                                    </p>
                                    <ng-container *ngIf="sec3.img == '1' ">
                                        <img src='./assets/images/norm35/GestionModelo.jpeg' class="centradoIMG ">
                                    </ng-container>

                                    <ng-container *ngIf="sec3.img == '2' ">
                                        <img src='./assets/images/norm35/TablaNorma.jpeg' class="centradoIMG ">
                                    </ng-container>
                                    <table class="" style="width: 100%; margin-bottom: 2%;">
                                        <tbody>
                                            <tr *ngFor="let des of sec3.descripcion">
                                                <th scope="col" style="width: 85%; text-align: left; font-weight: normal;">
                                                    {{des.des}}
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <br>
                            </div>
                        </form>
                    </mat-step>

                    <mat-step>
                        <ng-template matStepLabel>Página 4</ng-template>
                        <div fxFlex="1 0 auto" fxLayout="column">
                            <div *ngFor="let sec4 of Seccion4Better">
                                <p style="font-weight: bold">
                                    {{ sec4.pregunta }}
                                </p>
                                <table class="" style="width: 100%; margin-bottom: 2%;">
                                    <tbody>
                                        <tr *ngFor="let des of sec4.descripcion">
                                            <th scope="col" style="width: 85%; text-align: left; font-weight: normal;">
                                                {{des.des}}
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <br>
                        </div>
                    </mat-step>


                </mat-horizontal-stepper>

            </ng-container>

            <!-- / HORIZONTAL STEPPER EXAMPLE -->

        </div>





    </div>
    <!-- / CONTENT -->

</div>
